import { Collapse, Divider, Spin } from "antd";
import {
	ActionButtonComponent,
	AddDocumentContainer,
	AddItemsContainer,
} from "./style";
import { DocCategoryItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useDocumentContext } from "../../context/DocumentContext/DocumentContext";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

const EditDocument = () => {
	const { id } = useParams<{ id: string }>();
	const { updateDocument, getDocumentDetail, operationStatus } = useDocumentContext();

	useEffect(() => {
		if (id) {
			getDocumentDetail(id);
		}
	}, [id]);

	return (
		<AddDocumentContainer>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<AddItemsContainer>
					<h3>Doküman Güncelleme</h3>
					<Divider />
					<Collapse
						items={DocCategoryItems}
						expandIconPosition="end"
						bordered={false}
						expandIcon={({ isActive }) => (
							<UpOutlined rotate={isActive ? 0 : -180} />
						)}
						defaultActiveKey={["1", "2"]}
					/>
					<ActionButtonComponent>
						<MainButtonComponent onClick={updateDocument} loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
							Güncelle
						</MainButtonComponent>
					</ActionButtonComponent>
				</AddItemsContainer>
			</Spin>
		</AddDocumentContainer>
	);
};

export default EditDocument;
